module.exports = __webpack_public_path__ + "img/Uebersicht_Ohr_Mittel.cbc06830.jpg";